<template>
    <div class="pb0 pl0">
        <transition name="fade">
            <div v-if="error" class="notifix notifix-error">
                <i class="fa fa-times" style="position: absolute;top: 1rem;right: 1rem; cursor:pointer;" aria-label="close" @click="error=null"></i>

                <p>{{error}}</p>
            </div>
        </transition>




        <div class="field has-addons" style="position: relative;">


            <div id="local-dd" class="control is-expanded">
                <input
                        type="search" id="placesbox" class="input"
                        v-model="needle"
                        @keyup="getOptions($event)"
                        @keyup.down="toggleDown($event)"
                        @keyup.up="toggleUp($event)"
                        @keyup.enter="setPlace($event)"
                        @focus="needle === 'Distrito, concelho ou freguesia' ? needle = null : null"
                >
            </div>

            <div v-if="shouldAppear" id="results" :style="'min-width:'+w+'px;max-width:'+w+'px'">

                <p
                        :style="'min-width:'+(w-3)+'px;max-width:'+(w-3)+'px'"
                        class="result"
                        v-for="d, index in distritos"
                        v-if="d.nome_distrito.toLowerCase().indexOf(needle.toLowerCase()) === 0"
                        :id="'d-'+d.cod_distrito"

                        @click="needle = d.nome_distrito; selected = true;"




                >{{d.nome_distrito}} <span class="gray"> (Distrito)</span>
                </p>


                <p
                        :style="'min-width:'+(w-3)+'px;max-width:'+(w-3)+'px'"
                        class="result"
                        v-for="c, index in concelhos"
                        v-if="c.nome_concelho.toLowerCase().indexOf(needle.toLowerCase()) === 0"
                        :id="'c-'+c.cod_concelho"

                        @click="needle = c.nome_concelho; selected = true;"




                >{{c.nome_concelho}} <span class="gray"> (Concelho)</span>
                </p>


                <p
                        v-if="results"
                        :style="'min-width:'+(w-3)+'px;max-width:'+(w-3)+'px'"
                        class="result"
                        v-for="r, index in results"
                        :id="'f-'+r.cod_localidade"
                        :data-name="r.nome_abrev_localidade"
                        :data-distrito="r.cod_distrito"
                        :data-concelho="r.cod_concelho"
                        :data-localidade="r.cod_localidade"

                        @click="needle = r.nome_compl_localidade; selected = true;"


                >{{r.nome_compl_localidade}} <span class="gray"> ({{r.nome_concelho+', '+ r.nome_distrito}})</span>
                </p>

            </div>



        </div>


    </div>



</template>

<script>
import { notificationMixin } from "../plugins/notificationMixin";
import { distritos } from "../plugins/dist_conc";
import { concelhos } from "../plugins/dist_conc";
import { apiUrl } from "../vars";

export default {
  mixins: [notificationMixin],
  //props: ['search'],

  data() {
    return {
      w: 100,

      results: null,
      selectedResult: 0,
      selected: null,

      distritos,
      concelhos,

      needle: "Distrito, concelho ou freguesia"
    };
  },

  computed: {
    shouldAppear() {
      return !!this.needle && this.needle.length > 0 && !this.selected;
    },

    matches() {
      if (this.needle) {
        let matchesAry = [];
        for (let i = 0; i < this.services.length; i++) {
          if (
            this.services[i].title
              .trim()
              .toLowerCase()
              .indexOf(this.needle.toLowerCase()) !== -1
          ) {
            matchesAry.push(this.services[i]);
          }
        }
        if (matchesAry && matchesAry.length > 0) {
          this.fill = 5 - matchesAry.length;
        }
        return matchesAry;
      }
    }
  },

  watch: {
    needle: function(newVal, oldVal) {
      if (this.service) {
        if (newVal.trim().length !== this.service.title.trim().length) {
          this.reset();
        }
      }
    }
  },

  mounted() {
    this.setDdWidth();
  },

  methods: {
    setDdWidth() {
      //this.w = Math.max(document.getElementById('barcontrol').offsetWidth,240);
      //this.w = document.getElementById('barcontrol').offsetWidth;
      this.w =
        window.innerWidth -
        document.getElementById("placesbox").getBoundingClientRect().left -
        32;
    },

    setParentService(data) {
      this.$emit("setParentService", data);
      this.reset();
    },

    getOptions($event) {
      this.selected = false;
      if (
        $event.keyCode !== 38 &&
        $event.keyCode !== 40 &&
        $event.keyCode !== 13
      ) {
        let that = this;
        axios.get(apiUrl + "api/localidade/" + this.needle).then(res => {
          that.results = res.data.results;
        });
      }
    },

    setPlace($event) {
      let resultlist = document.getElementsByClassName("result");

      let place = {
        cod_distrito: null,
        cod_concelho: null,
        cod_localidade: null
      };

      let id = resultlist[this.selectedResult].id;
      switch (id.split("-")[0]) {
        case "f":
          place.cod_localidade = parseInt(
            resultlist[this.selectedResult].dataset.localidade
          );
          break;
        case "d":
          place.cod_distrito = parseInt(
            resultlist[this.selectedResult].dataset.distrito
          );
          break;
        case "c":
          place.cod_concelho = parseInt(
            resultlist[this.selectedResult].dataset.concelho
          );
          break;
      }

      this.needle = resultlist[this.selectedResult].dataset.name;
      this.selected = true;
      this.selectedResult = 0;

      this.$emit("setPlace", place);
    },

    toggleDown($event) {
      //let res = document.getElementById('result');

      let resultlist = document.getElementsByClassName("result");

      this.selectedResult < resultlist.length ? this.selectedResult++ : null;

      this.selectedResult > 0
        ? resultlist[this.selectedResult - 1].classList.remove("selected")
        : null;
      resultlist[this.selectedResult].classList.add("selected");
    },

    toggleUp($event) {
      let resultlist = document.getElementsByClassName("result");

      this.selectedResult > 0 ? this.selectedResult-- : null;

      //let res = document.getElementById('result');
      this.selectedResult > 0
        ? resultlist[this.selectedResult].classList.remove("selected")
        : null;
      resultlist[this.selectedResult + 1].classList.remove("selected");
      this.selectedResult > 0
        ? resultlist[this.selectedResult - 1].classList.add("selected")
        : null;
    },

    reset() {
      this.selected = null;
    },

    selectFromDropDown(item) {
      let o = {};
      Object.assign(o, item);
      this.needle = o.title.trim();
      this.selected = o;
    },
    promptSelection() {
      this.error = "Por favor, seleccione uma das opções disponíveis na lista.";
    }
  }
};
</script>
<style scoped lang="scss">
$input-height: 2rem;
$info: #2d3256;
$primary: #e90054;

#local-dd {
  margin-right: 1rem;
}

.input {
  font-size: 0.8rem;
  height: 2.1rem;
  margin-top: -0.05rem;

  border-radius: 0;

  background-color: #2d3253;
  border: solid 1px white;
  color: white;
}

.button {
  font-size: 1.5rem;
  padding: 1rem 2rem;
  height: 4rem;
  border-radius: 0 5px 5px 0;
}

.button-foot {
  border-radius: 0;
}

.mod-result {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 3rem;
  border-bottom: solid 1px #f5f5f5;
  cursor: pointer;
}

#results {
  top: $input-height;
  position: absolute;

  background-color: white;
  z-index: 4;

  -moz-box-shadow: 6px 10px 6px 1px rgba(50, 50, 50, 0.4);
  -webkit-box-shadow: 6px 10px 6px 1px rgba(50, 50, 50, 0.4);
  box-shadow: 6px 10px 6px 1px rgba(50, 50, 50, 0.4);
}

.result {
  line-height: $input-height * 0.8;
  padding: 0 0.25rem;
  z-index: 5;
  cursor: pointer;
  color: black;
  font-size: 0.8rem;
}

.result:hover {
  background-color: $info;
  color: white;
}

.selected {
  background-color: $info;
  color: white;
}

.ddcaret {
  padding-top: 0.8rem;
}

.more {
  color: $primary;
}
.more:hover {
  color: white;
}

.zero {
  color: #969696;
  font-style: italic;
  cursor: default;
}
.zero:hover {
  background-color: white;
  color: #969696;
}
</style>



// WEBPACK FOOTER //
// src/components/PlaceDropDown.vue